<script lang="ts" setup>
defineOptions({
    name: 'IdeoFormInputGroupText'
});

const props = withDefaults(defineProps<{
    embedded?: boolean;
}>(), {
    embedded: false
});
</script>

<template>
    <span
        :class="[
            'ideo-input-group-text inline-flex items-center px-[10px] py-0 text-ui-label/normal font-[400] text-fg-faint dark:text-fg-faint-dark',
            props.embedded ? 'h-[28px] shrink-0 border-0 bg-transparent' : 'h-[30px] rounded-[8px] border border-border-strong bg-transparent dark:border-border-strong-dark'
        ]"
    >
        <slot name="default" />
    </span>
</template>
